import { render, staticRenderFns } from "./SalesmanProductStatistics.vue?vue&type=template&id=f112f4cc&"
import script from "./SalesmanProductStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesmanProductStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanProductStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports